// Module
var code = `<dynamic-list
  columns="\$ctrl.columns"
  data="\$ctrl.loanTypes"
  sorting="\$ctrl.sorting"
>
</dynamic-list>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/customer/loans/new-loan/list/list-table/customer-loan-create-list-table.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;